import { KvdIcon, Title } from '@kvdbil/components';
import styled from 'styled-components';

const StyledTitle = styled(Title)`
  margin-bottom: 2rem;
`;

const MainIconWrapper = styled.div`
  font-size: 6rem;
  margin: 1.5rem 0 -0.5rem;
`;

const DisplayHeaderContainer = styled.div`
  text-align: center;
`;

interface DisplayHeaderProps {
  title?: string;
}

export const DisplayHeader = ({ title }: DisplayHeaderProps) => (
  <DisplayHeaderContainer>
    <MainIconWrapper>
      <KvdIcon />
    </MainIconWrapper>

    <StyledTitle>{title}</StyledTitle>
  </DisplayHeaderContainer>
);
